import type { TutLevelKey } from './tut-types';

export const TUT_DISABLED_KEYS = ['고급3', '고급4', '고급5', '고급6'];

export interface Tutor {
  tutId: number;
  tutKey?: string;
  level: TutLevelKey;
  img: string;
  title: string;
  substance: string;
  guideImg?: string;
  guideSubstance?: React.ReactNode;
  url?: string;
}

export const TUT_LECTURE_1: Tutor = {
  tutId: 1,
  tutKey: '기초',
  level: 'basic',
  img: '/_static/images/tut_card_ex1.png',
  title: '구성 익히기',
  substance: '기본적인 블록 코딩 구성과 사용 방법에 대해 배워 보세요.',
  guideImg: '/images/tutor/lecture-list/basic1_2.png',
  guideSubstance: (
    <>
      블록코딩 구성과 개념을 이해하고 <br />
      AI 튜터와 함께 사용 방법을 배워 보세요.
    </>
  ),
  url: '/tut/1',
};

export const TUT_LECTURE_2: Tutor = {
  tutId: 2,
  tutKey: '초급1',
  level: 'beginning',
  img: '/_static/images/tut_card_ex1.png',
  title: '개구리와 황소이야기',
  substance: '개구리와 황소 이야기를 통해 블록 코딩을 학습해 보세요',
  guideImg: '/images/tutor/lecture-list/beginner1_2.png',
  guideSubstance: (
    <>
      재미난 이야기를 통해 AI 튜터와 <br />
      블록 코딩 학습을 해 보세요.
    </>
  ),
  url: '/tut/2',
};
export const TUT_LECTURE_3: Tutor = {
  tutId: 3,
  tutKey: '초급2',
  level: 'beginning',
  img: '/_static/images/tut_card_ex1.png',
  title: '코디니의 버스 타기',
  substance: '코디니의 움직임을 제어하는 방법을 학습해 보세요.',
  guideImg: '/images/tutor/lecture-list/beginner2_2.png',
  guideSubstance: (
    <>
      오브젝트 동작 제어 방법에 대해 <br />
      학습하고 스스로 블록코딩 해보세요!
    </>
  ),
  url: '/tut/3',
};

export const TUT_LECTURE_4: Tutor = {
  tutId: 4,
  tutKey: '초급3',
  level: 'beginning',
  img: '/_static/images/tut_card_ex1.png',
  title: '코디니의 학교 가기 ',
  substance: '이벤트 블록을 학습하고 장면 전환 방법에 대해 배워 보세요. ',
  guideImg: '/images/tutor/lecture-list/beginner3_2.png',
  guideSubstance: (
    <>
      오브젝트와 배경을 추가하고 스토리에 어울리는 <br />
      장면으로 전화하는 방법을 학습해 보세요.
    </>
  ),
  url: '/tut/4',
};

export const TUT_LECTURE_5: Tutor = {
  tutId: 5,
  tutKey: '초급4',
  level: 'beginning',
  img: '/_static/images/tut_card_ex1.png',
  title: '변수를 활용한 보물 찾기',
  substance: '보물을 찾으며 변수의 개념과 사용 방법을 학습해보세요.',
  guideImg: '/images/tutor/lecture-list/beginner4_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      스스로 변수의 개념과 사용 방법에 대해서
      <br />
      학습하면서, 보물을 찾아보세요!
    </span>
  ),
  url: '/tut/5',
};

export const TUT_LECTURE_6: Tutor = {
  tutId: 6,
  tutKey: '중급1',
  level: 'intermediate',
  img: '/_static/images/tut_card_ex1.png',
  title: '햄버거 주문하기',
  substance: '음성합성을 이용해 햄버거를 주문해 보세요.',
  guideImg: '/images/tutor/lecture-list/intermediate1_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      코디니가 햄버거를 주문할 수 있도록
      <br />
      텍스트를 음성으로 변환해 보세요.
    </span>
  ),
  url: '/tut/6',
};

export const TUT_LECTURE_7: Tutor = {
  tutId: 7,
  tutKey: '중급2',
  level: 'intermediate',
  img: '/_static/images/tut_card_ex1.png',
  title: '코디니와 택시운전사 느림보씨',
  substance: '음성인식을 이용해서 택시운전사 느림보씨와 대화해 보세요.',
  guideImg: '/images/tutor/lecture-list/intermediate2_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      코디니가 빵집에 갈 수 있도록
      <br />
      음성인식을 사용하여 택시를 이용해 보세요!
    </span>
  ),
  url: '/tut/7',
};

export const TUT_LECTURE_8: Tutor = {
  tutId: 8,
  tutKey: '중급3',
  level: 'intermediate',
  img: '/_static/images/tut_card_ex1.png',
  title: '전설의 모아이를 찾아서',
  substance: '코디니와 탐험하며 인공지능 비서와 호출어에 대해 학습해 보세요.',
  guideImg: '/images/tutor/lecture-list/intermediate3_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      탐험가 코디니가 모아이의 비밀을 찾아
      <br />
      미션을 완수할 수 있도록 도와 주세요!
    </span>
  ),
  url: '/tut/8',
};

export const TUT_LECTURE_9: Tutor = {
  tutId: 9,
  tutKey: '중급4',
  level: 'intermediate',
  img: '/_static/images/tut_card_ex1.png',
  title: '코디니의 퀴즈Show!',
  substance: '제어문을 활용하여 MC코디니와 함께 퀴즈쇼를 진행해 보세요.',
  guideImg: '/images/tutor/lecture-list/intermediate4_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      퀴즈쇼의 진행을 맡은 코디니와 함께
      <br />
      재밌는 문제들을 만들어 볼까요?
    </span>
  ),
  url: '/tut/9',
};

export const TUT_LECTURE_10: Tutor = {
  tutId: 10,
  tutKey: '중급5',
  level: 'intermediate',
  img: '/_static/images/tut_card_ex1.png',
  title: '코디니와 화상통화',
  substance: '문자열과 관련된 블록을 이용해 코디니에게 가족을 소개해 보세요.',
  guideImg: '/images/tutor/lecture-list/intermediate5_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      고구미가 코디니에게 가족을 소개할 수 있도록
      <br />
      문자를 여러 방식으로 활용해 보세요!
    </span>
  ),
  url: '/tut/10',
};

export const TUT_LECTURE_11: Tutor = {
  tutId: 11,
  tutKey: '중급6',
  level: 'intermediate',
  img: '/_static/images/tut_card_ex1.png',
  title: '명탐정 코디니',
  substance: '문자 인식 기술로 명탐정 코디니와 사건을 해결해 보세요.',
  guideImg: '/images/tutor/lecture-list/intermediate6_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      코디니의 완벽한 추리를 도울 수 있도록
      <br />
      문자 인식 기술에 대해 학습해 보세요!
    </span>
  ),
  url: '/tut/11',
};

export const TUT_LECTURE_12: Tutor = {
  tutId: 12,
  tutKey: '중급7',
  level: 'intermediate',
  img: '/_static/images/tut_card_ex1.png',
  title: '코디니와 세계 명소 여행',
  substance: 'AI가 알려주는 정보를 따라 세계 명소를 여행해 보세요.',
  guideImg: '/images/tutor/lecture-list/intermediate7_2.png',
  guideSubstance: (
    <span style={{ color: '#000' }}>
      코디니와 함께 이미지 속 세계 명소를 여행하며
      <br />
      명소 인식 기술에 대해 학습해 보세요!
    </span>
  ),
  url: '/tut/12',
};

export const TUT_LECTURE_13: Tutor = {
  tutId: 13,
  tutKey: '고급1',
  level: 'advanced',
  img: '/_static/images/tut_card_ex1.png',
  title: '코디니를 도와줘!',
  substance: '여러 유틸리티 블록들을 이용해 문장을 새롭게 구성해 보세요!',
  guideImg: '/images/tutor/lecture-list/advanced1_2.png',
  guideSubstance: (
    <span style={{ color: '#000' }}>
      받아쓰기 시험에 어려움을 겪는 코디니,
      <br />
      문자열에 대해 학습하며 오답노트 작성을 도와주자!
    </span>
  ),
  url: '/tut/13',
};

export const TUT_LECTURE_14: Tutor = {
  tutId: 14,
  tutKey: '고급2',
  level: 'advanced',
  img: '/_static/images/tut_card_ex1.png',
  title: '스핑크스의 수수께끼',
  substance: '속성 탭에서 리스트를 만들고 블록으로 이용해 보세요.',
  guideImg: '/images/tutor/lecture-list/advanced2_2.png',
  guideSubstance: (
    <span style={{ color: '#000' }}>
      문지기 스핑크스를 보며 고민 중인 이집트 코디니,
      <br />
      수수께끼를 만들어 파라오의 무덤을 지키자!
    </span>
  ),
  url: '/tut/14',
};

export const TUT_LECTURE_15: Tutor = {
  tutId: 15,
  tutKey: '고급3',
  level: 'advanced',
  img: '/_static/images/tut_card_ex1.png',
  title: '코디니의 과일가게',
  substance: '데이터 세트를 만들어 코디니와 과일가게를 운영해 보세요.',
  guideImg: '/images/tutor/lecture-list/advanced3_2.png',
  guideSubstance: (
    <span style={{ color: '#000' }}>
      매번 가격을 잊어버려 걱정하고 있는 코디니에게
      <br />
      과일 이름만 알아도 가능한 방법을 알려 주세요!
    </span>
  ),
  url: '/tut/15',
};

export const TUT_LECTURE_16: Tutor = {
  tutId: 16,
  tutKey: '고급4',
  level: 'advanced',
  img: '/_static/images/tut_card_ex1.png',
  title: '버츄얼 전시회에 초대합니다',
  substance: '생성모델로 나의 아바타를 만들어 전시회를 즐겨 보세요!',
  guideImg: '/images/tutor/lecture-list/advanced4_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      생성모델로 가상 작품을 만드는 작가 코디니의
      <br />
      첫번째 전시회에 초대합니다.
    </span>
  ),
  url: '/tut/16',
};

export const TUT_LECTURE_17: Tutor = {
  tutId: 17,
  tutKey: '고급5',
  level: 'advanced',
  img: '/_static/images/tut_card_ex1.png',
  title: '힘내! 코디니맨!',
  substance: '텍스트 분류를 이용한 판별기로 코디니맨 게임을 조종해 보자.',
  guideImg: '/images/tutor/lecture-list/advanced5_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      응원을 해주면 힘이 세지고,
      <br />
      비난을 하면 힘이 약해지는 히어로 코디니맨.
    </span>
  ),
  url: '/tut/17',
};

export const TUT_LECTURE_18: Tutor = {
  tutId: 18,
  tutKey: '고급6',
  level: 'advanced',
  img: '/_static/images/tut_card_ex1.png',
  title: '무엇이든 예측 시계',
  substance: '단순 회귀 분석을 이용한 예측 시계를 만들고 사용해 보세요.',
  guideImg: '/images/tutor/lecture-list/advanced6_2.png',
  guideSubstance: (
    <span style={{ color: '#fff' }}>
      원하는 연도를 설정하면 예측해주는 시계!
      <br />
      과연 농부 코디니의 고민을 해결해 줄 수 있을까?
    </span>
  ),
  url: '/tut/18',
};

export const UNDER_DEVELOP: Tutor = {
  tutId: 99,
  level: 'advanced',
  img: '/_static/images/tut_card_ex1.png',
  title: '새로운 강좌가 추가될 예정입니다',
  substance: '',
};

export const TUT_LECTURE_LIST: Tutor[] = [
  TUT_LECTURE_1,
  TUT_LECTURE_2,
  TUT_LECTURE_3,
  TUT_LECTURE_4,
  TUT_LECTURE_5,
  TUT_LECTURE_6,
  TUT_LECTURE_7,
  TUT_LECTURE_8,
  TUT_LECTURE_9,
  TUT_LECTURE_10,
  TUT_LECTURE_11,
  TUT_LECTURE_12,
  TUT_LECTURE_13,
  TUT_LECTURE_14,
  TUT_LECTURE_15,
  TUT_LECTURE_16,
  TUT_LECTURE_17,
  TUT_LECTURE_18,
  UNDER_DEVELOP,
].filter((tut) => !TUT_DISABLED_KEYS.includes(tut.tutKey ?? ''));

export const TUT_LECTURE_MAP = TUT_LECTURE_LIST.reduce(
  (acc, cur) => {
    const arr = acc[cur.level] ? acc[cur.level] : [];
    acc[cur.level] = arr;
    arr.push(cur);
    return acc;
  },
  {} as Record<Partial<TutLevelKey>, Tutor[]>,
);
